import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import { TextArea, TextInput } from '../../components/FormComponents'
import PageTitle from '../../components/PageTitle'
import Table from '../../components/Table'
import FeatherIcon from 'feather-icons-react';
import Popup from '../../components/Popup';
import { VerticalForm } from '../../components'
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const API = process.env.REACT_APP_CLIENT_IP;

function UserRoleSettings() {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [data, setData] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [inputData, setInputData] = useState({})
    const [validated, setValidated] = useState({ progress: false, login: false });
    const [notify, setNotify] = useState({ show: false, variant: '', message: '' })
    const [showPop, setShowPop] = useState({ show: false, dataId: '' })

    const columns = [
        {
            Header: 'User Role',
            accessor: 'userRoleName',
            sort: true,
        },
        {
            Header: 'Description',
            accessor: 'description',
            sort: false,
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: (cell) => {
                let { original } = cell.cell.row;
                //console.log(cell.cell.row.id)
                return <div style={{ display: 'flex', flexDirection: 'row', border: 'none', alignItems: 'center' }}>
                    <FeatherIcon onClick={() => {
                        setShow(true); setInputData(original)
                    }} style={{ cursor: 'pointer' }} className="icon-dual-info" icon="edit-2" />
                    <FeatherIcon onClick={() => {
                        setShowPop({ show: true }); setInputData(original)
                    }} style={{ marginLeft: '3px', cursor: 'pointer' }} className="icon-dual-danger" icon="trash-2" />
                </div>
            }
        }
    ];

    const sizePerPageList = [
        {
            text: '5',
            value: 5,
        },
        {
            text: '10',
            value: 10,
        },
        {
            text: '25',
            value: 25,
        },
        {
            text: 'All',
            value: data.length,
        },
    ];

    const schema = yup.object().shape({
        userRoleName: yup.string().required(t('Please enter User Role Name')),
    })

    const schemaResolver = yupResolver(schema);

    const handleChange = (event) => {
        const { name, value } = event.target
        setInputData({
            ...inputData, [name]: value
        })
        if (name === 'userRoleName' && value !== '') {
            setValidated({ ...validated, [name]: false });
        } else { setValidated({ ...validated, [name]: true }); }
    }

    const fetchRecords = async () => {
        let res = await fetch(`${API}/api/userrole/list`).then(response => response.json());
        if (res.success) {
            setData(res.data);
            console.log(res.data);
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            let isValid = schema.validateSync(inputData);
            if (isValid) {
                if (inputData.userRoleId === 0 || inputData.userRoleId === undefined) {
                    inputData.userRoleId = undefined;
                    const data = JSON.stringify(inputData);
                    try {
                        let res = await fetch(`${API}/api/userrole/create`, {
                            method: 'POST',
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: data
                        }).then(response => response.json());
                        if (res.success) {
                            setNotify({ show: true, variant: 'success', message: 'Saved Successfully!' })
                            setInputData({})
                            fetchRecords();
                            handleClose();
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        } else {
                            setNotify({ show: true, variant: 'warning', message: res.error ? res.error.msg : "Something went wrong" })
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    const data = JSON.stringify(inputData);
                    try {
                        let res = await fetch(`${API}/api/userrole/${inputData.userRoleId}`, {
                            method: 'PUT',
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: data
                        }).then(response => response.json());
                        if (res.success) {
                            setNotify({ show: true, variant: 'success', message: 'Updated Successfully!' })
                            setInputData({})
                            fetchRecords();
                            handleClose();
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        } else {
                            setNotify({ show: true, variant: 'warning', message: res.error ? res.error.msg : "Something went wrong" });
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
        } catch (error) {
            error && setValidated({ userRoleName: true, progress: false });
        }
    };

    const onDelete = async (id) => {
        try {
            let res = await fetch(`${API}/api/userrole/${id}`, {
                method: 'DELETE'
            }).then(response => response.json());
            if (res.success) {
                fetchRecords();
                setInputData({});
                setShowPop({ show: false, dataId: '' })
                setNotify({
                    show: true,
                    message: "Deleted Successfully!",
                    variant: "success",
                });
                setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
            } else {
                setNotify({
                    show: true,
                    message: `${res.data.error.msg}`,
                    variant: "danger",
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => fetchRecords(), []);
  return (
    <React.Fragment>
        <PageTitle
                breadCrumbItems={[
                    { label: 'User Settings', path: '/settings/userrolelist' },
                    { label: 'User Role', path: '/settings/userrolelist', active: true },
                ]}
                title={'User Role'}
            />
            <Popup show={showPop.show}
                handleClose={() => setShowPop({ show: false })}
                handleDelete={() => onDelete(inputData.userRoleId)}
            />
            <Alert show={notify.show} variant={notify.variant} >{notify.message}</Alert>

            <Modal show={show} size='lg' centered>
                <Modal.Header onHide={handleClose} closeButton>
                    <p className="text-muted fs-14">
                        Fill in the required details
                    </p>
                </Modal.Header>

                <Row>
                    <Col>
                        <Card>
                            <Card.Body>

                                <VerticalForm resolver={schemaResolver} onSubmit={handleSubmit}>
                                    <Row>
                                        <Col lg={12}>
                                            <TextInput
                                                textTitle={'User Role Name'}
                                                textName='userRoleName'
                                                value={inputData.userRoleName}
                                                required={!inputData.userRoleName&&validated.userRoleName}
                                                onChange={handleChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <TextArea
                                                AreaTitle={'Description'}
                                                areaName='description'
                                                value={inputData.description}
                                                onChange={handleChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Button style={{ float: 'right' }} variant="primary" type="submit" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </VerticalForm>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Modal>

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col xs={8}>
                                    <h4 className="header-title">userroles</h4>
                                    <p className="text-muted fs-14 mb-4">List of userroles</p>
                                </Col>
                                <Col xs={4}>
                                    <Button style={{ float: 'right' }} variant="success"
                                        type="submit" className="btn-sm" onClick={handleShow}>
                                        Add New
                                        <i className='bi-plus-lg' style={{ marginLeft: '5px', fontSize: '' }}></i>
                                    </Button>
                                </Col>
                            </Row>

                            <Table
                                columns={columns}
                                data={data}
                                pageSize={5}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                isSearchable={true}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
    </React.Fragment>
  )
}

export default UserRoleSettings